import { Directive, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

export function postcodeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const patten = new RegExp(/[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}/i);
    return (!control.value || patten.test(control.value)) ? null : { postcodeValidator: { value: control.value } };
  };
}

@Directive({
  selector: '[validPostcode]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidPostcodeDirective, multi: true }]
})
export class ValidPostcodeDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl): { [key: string]: any } {
    return postcodeValidator()(control);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/shared/valid-postcode.directive.ts